import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/products',
  title: 'title',
  endpoint: '/public/store_product',
}
